import React, {
  useState,
  useRef,
  useEffect,
} from "react";
import {
  Box,
  Container,
  Stack,
  Typography,
} from "@mui/material";

import { set } from "lodash";

import {
  getOptions,
  putOptions,
  AccountUrl_get,
  AccountUrl_put,
  ftchPlus,
  CleanAvail,
} from "../../App/Account_urls.jsx";
import ValueInflatable from "../../App/ValueInflatable.jsx";
import { AddDialog } from "../../Components/AddDialog.jsx";
import { InputAge } from "../../Components/Inputs/Input_Age.jsx";
import { InputPercentage } from "../../Components/Inputs/Input_Percentage.jsx";
import { Input_label, InputName } from "../../Components/Inputs/Input_Name.jsx";
import { errorClear, errorSetPlus } from "../../Components/Inputs/Input_Fns.jsx";
import { CollapseDelete } from "../../App/CollapseButtons.jsx";
import { InputSelect1, InputSelectMonth } from "../../Components/Inputs/Select.jsx";
import { Arrayify } from "../../Functions/utils.jsx";
import { InputCheck } from "../../Components/Inputs/Input_Check.jsx";


var defDB = {
  Name: "",
  TaxFree: false,
  Annual: {
    Value: 0,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Yearly",
    Rate: 0,
    RateCap: 0,
    RateMultiplier: 0,
    RateOffset: 0,
  },
  StartAge: 65,
  StartMonth: "",
  Bridge: {
    Value: 0,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Yearly",
    Rate: 0,
    RateCap: 0,
    RateMultiplier: 0,
    RateOffset: 0,
  },
  BridgeStartAge: 55,
  BridgeStartMonth: "",
  BridgeEndAge: 64,
  SurvivorPercentage: 60,
  Comment: "",
  PensionAdjustment: {
    Value: 0,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Yearly",
    Rate: 0,
  },
  PAContType: "RRSP",
  GuaranteeYears: 0,
};

const Annual = ({ avail, form, onChange, onError, birthYear }) => {
  const [errors, setErrors] = useState({})

  const onChange_any = (n, v) => {

    let nf = {
      ...form,
      [n]: v,
    };
    //console.log(nf);
    onChange(nf);
  };

  const onChangeInfValue = (form, upto, spousePercentage, name) => {
    onChange_any(name, form);
  };



  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  const onChangeMe = (e, i) => {

    let json = form;
    json.Init[i] = e;
    onChange_any("Init", json.Init);
  };


  const onDelete = (e, Id) => {
    let json = form.Init.slice();
    json = json.filter((o) => o.Id !== Id);
    onChange_any("Init", json);
  };
  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  return (
    <Container maxWidth="true">
      <Box sx={{ my: 2, p: 2, border: "1px solid grey" }}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={2}>
            <Typography id="s-die-age-slider" variant="h6" gutterBottom>
              Basic
            </Typography>
            <Box>
              <InputCheck
                label="Tax Free"
                name="TaxFree"
                value={form.TaxFree}
                sx={{ ml: 5, mt: -1, mb: 2 }}
                tooltip="Certain pensions may be tax free, check this to make this pension Tax Free."
                onChange={onChange_any}
              />
            </Box>
          </Stack>


          <Stack direction="row" spacing={2}>

            <InputAge
              label="Start Age"
              name="StartAge"
              age={form.StartAge}
              onChange={onChange_t}
              // some military pensions are 20 years after start
              min={form.Annual.Value > 0 ? 35 : 0}
              max={72}
              tooltip="Age to start this pension"
              onError={(e) => myError("startage", null, e)}
              birthYear={birthYear}

            />
            <InputSelectMonth
              label="Month"
              name="StartMonth"
              value={form.StartMonth}
              onChange={onChange_t}
              errors={errors}
              tooltip="Month you will start collecting your pension, default is your birth month."
              onError={(e) => myError("startmonth", null, e)}
            />
            {/* <InputAge
            label="Guar. Years"
            name="GuaranteeYears"
            age={form.GuaranteeYear}
            max={30}
            onChange={onChange_t}
            tooltip="Number of years for which the full value is guaranteed"
            onError={(e) => myError("guaryears", null, e)}
            disabled
          /> */}

            <InputPercentage
              label=" % Survivor"
              name="SurvivorPercentage"
              percent={form.SurvivorPercentage}
              onChange={onChange_t}
              width={100}
              tooltip="Percentage of the value for the surviving spouse, after any guaranteed years"
              onError={(e) => myError("inputpercent", null, e)}
            />
            <ValueInflatable
              key="pension.value"
              form={form.Annual}
              onChange={onChangeInfValue}
              doInfCap={true}
              doInfMult={true}
              doInfOffset={true}
              avail={avail}
              tooltip="Value of the Defined Benefit in the first year of the pension"
              name="Annual"
              onError={(e) => myError("valueI", null, e)}

            />
          </Stack>


          <Typography id="s-die-age-slider" variant="h6" gutterBottom>
            Bridge
          </Typography>
          <Stack direction="row" spacing={2}>
            {/* <InputAge
            label="Start Age"
            name="BridgeStartAge"
            age={form.BridgeStartAge}
            onChange={onChange_t}
            min={form.Bridge.Value > 0 ? 35 : 0}
            max={72}
            tooltip="The first year of the bridge benefit"
            onError={(e) => myError("bridgestartage", null, e)}
          />
          <InputSelectMonth
            label="Month"
            name="BridgeStartMonth"
            value={form.BridgeStartMonth}
            onChange={onChange_t}
            errors={errors}
            tooltip="Month you will start collecting your bridge, default is your birth month."
            onError={(e) => myError("bridgestartmonth", null, e)}
          /> */}
            <InputAge
              name="BridgeEndAge"
              age={form.BridgeEndAge}
              onChange={onChange_t}
              min={form.Bridge.Value > 0 ? (form.BridgeStartAge > 0 ? Number(form.BridgeStartAge) + 1 : 0) : 0}
              max={72}
              tooltip="(Usually 64) The bridge will be up to this age, and up to the birthMonth of the following age."
              onError={(e) => myError("bridgeendage", null, e)}
              birthYear={birthYear}

            />
            <ValueInflatable
              key="bridge.pension.value"
              form={form.Bridge}
              onChange={onChangeInfValue}
              doInfCap={true}
              doInfMult={true}
              doInfOffset={true}
              avail={avail}
              name="Bridge"
              tooltip="Value of the Bridge Benefit in the first year of the bridge.  This should not include the basic value"
              onError={(e) => myError("bridgevalueI", null, e)}


            />
          </Stack>

          <Input_label
            label="Notes"
            name="Comment"
            value={form.Comment}
            maxLength={800}
            width={800}
            required={false}
            onChange={onChange_t}
            errors={errors}
            onError={(name, e) => myError(name, null, e)}
          />

        </Stack>

        <Typography sx={{ mt: 8 }} id="s-die-age-slider" variant="h6" gutterBottom>
          Pension Adjustment
        </Typography>
        <Stack spacing={2}>
          <InputSelect1
            label="Return Type"
            value={form.PAContType}
            onChange={onChange_t}
            name="PAContType"
            avail={avail.PAContTypes}
          />
          <ValueInflatable
            key="bridge.pensionadjust.value"
            form={form.PensionAdjustment}
            onChange={onChangeInfValue}
            avail={avail}
            name="PensionAdjustment"
            onError={(e) => myError("pensionadjustvalueI", null, e)}

          />
        </Stack>
        <Typography id="s-die-age-slider" variant="h6" gutterBottom>
          Related Employment Account
        </Typography>



        <InputSelect1
          label="Related Employment Account"
          value={form.EmploymentAccount}
          onChange={onChange_t}
          name="EmploymentAccount"
          avail={avail.EmploymentAccounts}
          minWidth={260}
          tooltip="This is for certain scenario operations such as a Retirement Sweep, as Employment continues MyOwnFP will adjust the StartAge (bridge or Basic)"
        // sx={{ m: 1, pb: 4 }}
        />
      </Box>
    </Container>
  );
};

const AddDBPensionAccount = ({
  show,
  close,
  client_p,
  clientJson,
  c_callback,
  account,
  account_uuid,
  accountType,
  add,
}) => {
  const data = useRef();
  const [form, setForm] = useState();
  const [dataset, setDataset] = useState();
  const [client, setClient] = useState(client_p);
  const [clients, setClients] = useState([client_p]);
  const [errors, setErrors] = useState({})
  const [errmsg, setErrmsg] = useState("")
  const [deleted, setDeleted] = useState(false)

  const getInputData = (client_) => {

    let url = AccountUrl_get(clientJson, "db", account, account_uuid, add, accountType);
    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          data.current = json;
          setForm(json);
          setClients(json.Clients);
          Update(client_);
          //console.log(data.current);
        }
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  const myClose = () => {
    data.current = null;
    setDataset(null);
    close(accountType);
  };

  const putRequest = async () => {
    let url = AccountUrl_put(
      clientJson,
      "db",
      form.DataSet[client].Name,
      form.DataSet[client].AccountUuid,
      form.DataSet[client].NameOrig,
      add
    );

    var req = putOptions;
    let post = CleanAvail(form)
    req.body = JSON.stringify(post);
    ftchPlus(url, req)
      .then((response) => {
        console.log("update completed");
        myClose();
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  const onSubmit = () => {
    console.log(form);
    putRequest();
  };

  useEffect(() => {
    if (show) {
      errorClear(errors)
      setErrmsg("")
      setDeleted(false)
      getInputData(client_p);
    }
  }, [show]);

  const Update = (cl) => {
    setClient(cl);
    setDataset(data.current.DataSet[cl]);
  };


  const onChange_any = (subpath, any) => {
    let path = "DataSet[" + client + "]";
    if (subpath !== "") {
      path += "." + subpath;
    }

    let nf = form;
    nf = set(nf, path, any);
    setForm(nf);
    nf = {
      ...nf,
    };
    setForm(nf);

    Update(client);
    //console.log(nf);
  };
  const onChangeMe = (e, i) => {

    if (e.Annual.length !== 0) {
      let path = "Annual[" + i + "]";
      onChange_any(path, e);
    } else {

      let path = "Annual[" + i + "]";
      onChange_any(path, e);
      let json = data.current.DataSet[client].Annual.slice();
      json = json.filter((o) => o.Init.length !== 0);
      //console.log(json);
      onChange_any("Annual", json);
    }
  };

  const onClientChange = (cl) => {
    Update(cl);
  };

  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };



  const onDelete = (e, Id) => {
    let json = dataset.Annual.slice();
    json = json.filter((o) => o.Id !== Id);
    onChange_any("Annual", json);
    setDeleted(true)
  }

  const onError = (obj, i, err) => {
    if (i !== null) {
      obj += "[" + i + "]"
    }
    let e = set(errors, obj, err)
    setErrors(e)
  }


  return (
    <>
      <AddDialog
        clientJson={clientJson}
        c_callback={c_callback}
        onClose={myClose}
        open={show}
        clients={clients}
        client={client}
        label={accountType}
        accountType={accountType}
        onClientChange={onClientChange}
        onSubmit={onSubmit}
        errors={errors}
        errmsg={errmsg}
        deleted={deleted}

      >
        {data !== null && dataset !== undefined && dataset !== null && (
          <Stack sx={{ mx: 4 }}>
            {dataset !== undefined && (
              <Stack spacing={2}>
                <InputName
                  key="ds.name"
                  value={dataset.Name}
                  accountName={true}
                  onChange={onChange_t}
                  onError={(e) => onError("Name", null, e)}

                />
                <Stack direction="row" spacing={2}>
                  {dataset !== undefined && (
                    <>
                      <Stack spacing={2}>
                        {Arrayify(dataset.Annual).map((d, i) => (
                          <Stack key={i} direction="row" spacing={2}>
                            <Annual
                              avail={dataset.Avail}
                              form={d}
                              onChange={(e) => onChangeMe(e, i)}
                              onError={(e) => onError("value", i, e)}
                              birthYear={dataset.BirthYear}
                            />
                            <Stack sx={{ py: 4 }}>
                              <CollapseDelete
                                onClick={(e) => onDelete(e, d.Id)}
                              />
                            </Stack>
                          </Stack>
                        ))}
                      </Stack>
                    </>
                  )}

                </Stack>
              </Stack>
            )}
          </Stack>
        )}
      </AddDialog>
    </>
  );
};

export default AddDBPensionAccount;
